import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbainashikcab() {



const cardData = {
  keyword: "Mumbai Nashik Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Nashik cab services for travelers looking for a seamless journey to one of Maharashtra’s historic and cultural hubs. Whether you are planning a religious visit, a vineyard tour, a weekend getaway, or a corporate trip, our cab service ensures safe and convenient travel with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet features air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers, suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, timely pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Nashik cab services.",

topPlaces: [
  {
    title: "Trimbakeshwar Temple",
    description:
      "Trimbakeshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva and is located near Nashik. The temple is known for its intricate architecture, spiritual significance, and sacred rituals. Devotees from across India visit to perform abhishekam and participate in daily prayers. A cab ride ensures comfortable travel to the temple, allowing visitors to reach early, avoid the stress of local transport, and explore the nearby Godavari riverbanks and sacred sites at a relaxed pace."
  },
  {
    title: "Sula Vineyards",
    description:
      "Sula Vineyards is a premier wine destination in Nashik, famous for its world-class wines, vineyard tours, and wine tasting experiences. Visitors can explore the lush vineyards, learn about wine production, enjoy guided tastings, and dine at the vineyard’s restaurants. Traveling by cab from Mumbai allows travelers to comfortably plan their visit, enjoy scenic drives through the countryside, and return without worrying about designated drivers or public transport, making it ideal for a relaxed day or weekend trip."
  },
  {
    title: "Pandavleni Caves",
    description:
      "The Pandavleni Caves are a group of 24 rock-cut Buddhist caves dating back to the 1st century BCE, located on a hill overlooking Nashik. Visitors can explore ancient sculptures, inscriptions, and stupas while enjoying panoramic views of the city and surrounding landscapes. A cab service makes it easy to reach the caves, navigate the hilly terrain comfortably, and spend ample time exploring historical architecture without the rush of public transportation."
  },
  {
    title: "Kalaram Temple",
    description:
      "Kalaram Temple, dedicated to Lord Rama, is a historic temple in Nashik known for its black stone idol and traditional Dravidian-style architecture. The temple is an important site during festivals like Ram Navami and attracts numerous pilgrims. Traveling by cab ensures a hassle-free visit, providing flexibility in timing, convenient parking, and easy access to nearby markets and eateries where visitors can enjoy local Maharashtrian cuisine."
  },
  {
    title: "Ramkund",
    description:
      "Ramkund is a sacred bathing ghat on the Godavari River in Nashik, considered highly auspicious for pilgrims. Visitors perform ritual baths, offer prayers, and participate in religious ceremonies here. A cab service allows travelers to plan visits to Ramkund and nearby temples efficiently, making the spiritual experience more comfortable, especially during large gatherings or festivals like Kumbh Mela."
  },
  {
    title: "Anjneri Hill",
    description:
      "Anjneri Hill is believed to be the birthplace of Lord Hanuman and is popular among trekkers and spiritual travelers. The hill offers scenic trekking routes, panoramic views, and a serene environment for meditation and reflection. A cab ride ensures easy access to the base of the hill, comfortable transport of any gear or supplies, and enough flexibility to combine trekking with other Nashik sightseeing spots in a single day."
  },
  {
    title: "Coin Museum",
    description:
      "The Coin Museum in Nashik showcases an impressive collection of ancient coins, artifacts, and historical exhibits from different eras of Indian history. Visitors can learn about the region’s rich cultural and economic past through guided tours and informative displays. Using a cab to visit the museum provides convenient travel from hotels or other attractions, allowing travelers to plan a well-rounded itinerary without worrying about local transportation challenges."
  },
  {
    title: "Muktidham Temple",
    description:
      "Muktidham Temple is a marble temple dedicated to various Hindu deities and is designed to replicate famous pilgrimage sites from across India. Visitors can admire the detailed carvings, participate in prayers, and experience a spiritual ambiance. A cab service ensures hassle-free transport, letting travelers combine this visit with other attractions like Sula Vineyards or Ramkund comfortably within a day."
  },
  {
    title: "Coin Museum",
    description:
      "The Coin Museum in Nashik showcases an impressive collection of ancient coins, artifacts, and historical exhibits from different eras of Indian history. Visitors can learn about the region’s rich cultural and economic past through guided tours and informative displays. Using a cab to visit the museum provides convenient travel from hotels or other attractions, allowing travelers to plan a well-rounded itinerary without worrying about local transportation challenges."
  },
  {
    title: "Saptashrungi Devi Temple",
    description:
      "Saptashrungi Devi Temple is located on a hill near Nashik and is dedicated to Goddess Saptashrungi. The temple is an important pilgrimage site, attracting devotees who climb the hill to seek blessings. A cab ride provides a comfortable journey to the base and summit, allowing pilgrims to focus on spiritual activities without transportation worries, and enabling them to include other Nashik attractions like Trimbakeshwar and Sula Vineyards in their itinerary efficiently."
  }
],

services: [
{
name: "Mumbai to Nashik Cab",
description: "Mumbai to Nashik cab service provides comfortable and reliable transportation for travelers heading to the wine capital of India. Our AC sedans, SUVs, and premium vehicles ensure a smooth highway journey. Professional drivers are experienced with Mumbai–Nashik routes and provide safe travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for family trips, pilgrimage visits to Trimbakeshwar, and business travel."
},
{
name: "Mumbai to Nashik Taxi",
description: "Mumbai to Nashik taxi service offers convenient intercity travel for tourists, pilgrims, and corporate travelers. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers ensure safe driving and timely arrival. Flexible pickup options are available across Mumbai. Perfect for weekend trips, temple visits, and wine tourism."
},
{
name: "Mumbai to Nashik Cab Service",
description: "Mumbai to Nashik cab service is designed for travelers seeking reliable road transportation between the two cities. Well-maintained vehicles and professional drivers ensure smooth and safe highway journeys. Pickup is available from any location in Mumbai including airport terminals. Comfortable interiors make long-distance travel relaxing."
},
{
name: "Mumbai to Nashik Taxi Service",
description: "Mumbai to Nashik taxi service offers dependable travel for business trips, family travel, and pilgrimage journeys. AC vehicles provide comfortable seating for the entire trip. Professional drivers ensure safe highway driving. Flexible booking options allow easy trip planning."
},
{
name: "Cab from Mumbai to Nashik",
description: "Cab from Mumbai to Nashik provides a convenient private travel option for passengers planning intercity trips. Comfortable vehicles ensure smooth travel along the Mumbai–Nashik highway. Experienced drivers ensure safe and timely journeys. Ideal for family travel, tourism, and corporate travel."
},
{
name: "Taxi from Mumbai to Nashik",
description: "Taxi from Mumbai to Nashik offers reliable road transportation with comfortable AC vehicles and professional drivers. The service is ideal for families, business travelers, and tourists. Flexible pickup locations across Mumbai ensure convenient travel planning."
},
{
name: "Mumbai to Nashik Cab Booking",
description: "Mumbai to Nashik cab booking allows travelers to reserve vehicles easily for comfortable road travel. Instant confirmation and flexible pickup options make travel planning simple. Sedan, SUV, and premium vehicles are available for different travel needs."
},
{
name: "Mumbai to Nashik Taxi Booking Online",
description: "Online taxi booking from Mumbai to Nashik allows passengers to reserve vehicles instantly from anywhere. Quick confirmation and easy scheduling simplify travel planning. AC vehicles and trained drivers ensure smooth highway journeys."
},
{
name: "Mumbai to Nashik Cab Price",
description: "Mumbai to Nashik cab price is designed to offer affordable and transparent travel options. Customers can choose from sedan, SUV, or luxury vehicles depending on their needs. Clear fare details ensure no hidden charges."
},
{
name: "Mumbai to Nashik Taxi Fare",
description: "Mumbai to Nashik taxi fare is calculated with transparent per-km pricing and simple billing. Travelers can select vehicles based on group size and travel preferences. AC vehicles ensure comfortable long-distance travel."
},
{
name: "Mumbai to Nashik One Way Cab",
description: "One way cab from Mumbai to Nashik is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel costs while providing comfortable transportation. AC vehicles ensure relaxed highway journeys."
},
{
name: "Mumbai to Nashik Round Trip Taxi",
description: "Round trip taxi from Mumbai to Nashik offers complete travel convenience for passengers planning return journeys. Flexible return scheduling allows travelers to explore Nashik comfortably. Ideal for temple visits and wine tourism."
},
{
name: "Mumbai to Nashik Innova Cab",
description: "Innova cab from Mumbai to Nashik is perfect for families and groups needing spacious seating and luggage capacity. The premium MPV offers comfortable travel for long journeys. AC comfort and smooth suspension ensure relaxed travel."
},
{
name: "Mumbai to Nashik Ertiga Cab",
description: "Ertiga cab from Mumbai to Nashik provides comfortable travel for medium-size families and small groups. Spacious interiors ensure relaxed seating during the journey. AC comfort keeps passengers comfortable throughout the trip."
},
{
name: "Mumbai to Nashik Sedan Cab",
description: "Sedan cab from Mumbai to Nashik offers economical travel for couples and small families. Vehicles like Swift Dzire and Etios provide comfortable seating and smooth highway journeys. Ideal for budget-friendly travel."
},
{
name: "Mumbai to Nashik SUV Taxi",
description: "SUV taxi from Mumbai to Nashik is perfect for group travelers who require extra space and luggage capacity. Powerful vehicles ensure stable highway driving and comfortable travel. Ideal for family tours and corporate travel."
}
],

tableData: [
["Mumbai to Nashik Cab","Mumbai to Nashik Taxi"],
["Mumbai to Nashik Cab Service","Mumbai to Nashik Taxi Service"],
["Cab from Mumbai to Nashik","Taxi from Mumbai to Nashik"],
["Mumbai to Nashik Cab Booking","Mumbai to Nashik Taxi Booking Online"],
["Mumbai to Nashik Cab Price","Mumbai to Nashik Taxi Fare"],
["Mumbai to Nashik One Way Cab","Mumbai to Nashik Round Trip Taxi"],
["Mumbai to Nashik Innova Cab","Mumbai to Nashik Ertiga Cab"],
["Mumbai to Nashik Sedan Cab","Mumbai to Nashik SUV Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our professional drivers have extensive experience driving on the Mumbai to Nashik highway and understand the best routes, traffic patterns, and safe driving practices. Their expertise ensures a smooth and comfortable journey whether you are traveling for business, tourism, or religious visits."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and upfront pricing for Mumbai to Nashik cab services. We share complete fare details before booking so you can travel with confidence without worrying about hidden costs or unexpected charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cab service operates 24/7 to accommodate early morning departures, late-night travel, or urgent trips. No matter what time you plan to travel from Mumbai to Nashik, Omshree Cabs ensures reliable service and quick booking confirmation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned and well maintained for long-distance travel. Each car is thoroughly cleaned and sanitized before every trip so passengers enjoy a hygienic and comfortable ride."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible trip options including one-way travel, round trips, and customized travel schedules. Whether you are visiting Nashik for business meetings, religious trips to Trimbakeshwar, or vineyard tours, we adapt to your travel plans."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles. This allows travelers to choose the best option based on comfort, group size, and travel requirements."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We offer convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. Our drivers arrive on time and start your journey directly from your preferred location, making the travel experience easy and stress-free."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Omshree Cabs is known for dependable service and punctual pickups. Our drivers prioritize passenger safety and ensure timely arrival in Nashik while maintaining a smooth and comfortable travel experience."
  }
]
};


const faqData = [
  { question: "What is the distance between Mumbai and Nashik by cab?", answer: "The distance from Mumbai to Nashik is approximately 165 km and usually takes around 3–4 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Nashik cab services?", answer: "Yes, Omshree Cabs offers both one-way and round-trip cab services between Mumbai and Nashik." },
  { question: "Which vehicles are available for Mumbai to Nashik travel?", answer: "We offer sedans, SUVs like Ertiga and Innova, and premium cars depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Nashik trips." },
  { question: "Can I visit Trimbakeshwar temple during the trip?", answer: "Yes, many travelers combine Nashik city travel with Trimbakeshwar temple darshan, and our drivers are familiar with the route." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for a comfortable journey." },
  { question: "Can we stop for food or rest during the trip?", answer: "Yes, passengers can request rest stops during the journey for meals or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, or religious festival seasons in Nashik." },
  { question: "Do you offer same-day return trips?", answer: "Yes, Omshree Cabs provides same-day return packages for Mumbai to Nashik trips." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Shah",
    feedback:
      "Booked Omshree Cabs for a Mumbai to Nashik trip. The driver was punctual and the car was very clean. The journey was smooth and comfortable. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback:
      "We used Omshree Cabs for a family trip from Mumbai to Nashik and Trimbakeshwar. Excellent service, polite driver, and transparent pricing. Will definitely book again.",
    rating: 5
  }
];


























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Nashik Cab",
  "description": "Book Mumbai to Nashik Cab with Omshree Cab for safe, comfortable, and reliable outstation travel. Choose from Innova, Ertiga, Sedan, and SUV cabs for one-way or round trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Nashik.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3800"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Nashik Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Nashik Cab with Omshree Cab for safe, comfortable, and reliable outstation travel. Choose from Innova, Ertiga, Sedan, and SUV cabs for one-way or round trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Nashik." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbainashikcab;